export const COLUMN_SORT_SCHEMES = {
  STANDARD: 'standard',
  DATETIME: 'datetime',
  STRING: 'string',
  HIGH_LOW: 'high_low',
  MOST_FEWEST: 'most_fewest',
  CUSTOM: 'custom',
} as const;

export const FILTER_WIDGETS = {
  SELECT: 'select',
  OP_DEF: 'op_def',
  PROCESS: 'process',
  TEAM_MEMBER: 'team_member',
  CONTACT: 'contact',
  ACCOUNT: 'account',
  DATETIME: 'datetime',
  METADATA: 'metadata',
  FACILITY: 'facility',
  NUMERIC: 'numeric',
} as const;

export const SELECT_FILTER_WIDGETS = [
  FILTER_WIDGETS.SELECT,
  FILTER_WIDGETS.OP_DEF,
  FILTER_WIDGETS.PROCESS,
  FILTER_WIDGETS.TEAM_MEMBER,
  FILTER_WIDGETS.CONTACT,
  FILTER_WIDGETS.ACCOUNT,
  FILTER_WIDGETS.FACILITY,
] as const;

export const DATETIME_FILTER_WIDGETS = [FILTER_WIDGETS.DATETIME] as const;

export const METADATA_FILTER_WIDGETS = [FILTER_WIDGETS.METADATA] as const;

export const NUMERIC_FILTER_WIDGETS = [FILTER_WIDGETS.NUMERIC] as const;

export const FILTER_TYPES = {
  DATETIME: 'datetime',
  SELECT: 'select',
  METADATA: 'metadata',
  NUMERIC: 'numeric',
} as const;
